
import { Suspense } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import FloatingSocialIcons from '../../components/base/FloatingSocialIcons';

const CookiesPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-cyan-50 to-blue-50 relative overflow-hidden">
      <FloatingSocialIcons />
      <Header />
      
      <main className="relative z-10">
        <section className="py-20 px-6">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-blue-600 via-cyan-500 to-blue-400 bg-clip-text text-transparent text-center">
              Cookie Use Policy
            </h1>
            <p className="text-center text-gray-600 mb-12">Last Updated: January 2024</p>

            <div className="bg-white/80 backdrop-blur-sm rounded-3xl p-8 md:p-12 shadow-2xl space-y-8">
              <section>
                <h2 className="text-2xl font-bold mb-4 text-gray-800">1. What Are Cookies?</h2>
                <p className="text-gray-700 leading-relaxed">
                  Cookies are small text files that are placed on your computer or mobile device when you visit a website. They are widely used to make websites work more efficiently and provide information to the owners of the site. Cookies help us understand how you use our website and improve your experience.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4 text-gray-800">2. How We Use Cookies</h2>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Digital Experience Studio uses cookies for several purposes:
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                  <li>To enable certain functions of the website</li>
                  <li>To provide analytics and track website usage</li>
                  <li>To store your preferences and settings</li>
                  <li>To enable social media features</li>
                  <li>To deliver relevant advertising</li>
                  <li>To improve website performance and user experience</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4 text-gray-800">3. Types of Cookies We Use</h2>
                
                <div className="space-y-6">
                  <div className="bg-blue-50 rounded-xl p-6">
                    <h3 className="text-xl font-bold mb-2 text-gray-800">Essential Cookies</h3>
                    <p className="text-gray-700">
                      These cookies are necessary for the website to function properly. They enable basic functions like page navigation and access to secure areas of the website. The website cannot function properly without these cookies.
                    </p>
                  </div>

                  <div className="bg-cyan-50 rounded-xl p-6">
                    <h3 className="text-xl font-bold mb-2 text-gray-800">Analytics Cookies</h3>
                    <p className="text-gray-700">
                      These cookies help us understand how visitors interact with our website by collecting and reporting information anonymously. This helps us improve our website and services.
                    </p>
                  </div>

                  <div className="bg-blue-50 rounded-xl p-6">
                    <h3 className="text-xl font-bold mb-2 text-gray-800">Functionality Cookies</h3>
                    <p className="text-gray-700">
                      These cookies enable the website to provide enhanced functionality and personalization. They may be set by us or by third-party providers whose services we have added to our pages.
                    </p>
                  </div>

                  <div className="bg-cyan-50 rounded-xl p-6">
                    <h3 className="text-xl font-bold mb-2 text-gray-800">Marketing Cookies</h3>
                    <p className="text-gray-700">
                      These cookies are used to track visitors across websites. The intention is to display ads that are relevant and engaging for the individual user and thereby more valuable for publishers and third-party advertisers.
                    </p>
                  </div>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4 text-gray-800">4. Third-Party Cookies</h2>
                <p className="text-gray-700 leading-relaxed mb-4">
                  In addition to our own cookies, we may also use various third-party cookies to report usage statistics of the website and deliver advertisements on and through the website. These include:
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                  <li>Google Analytics for website analytics</li>
                  <li>Social media platforms (Facebook, Instagram, Twitter) for social sharing features</li>
                  <li>Advertising networks for targeted advertising</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4 text-gray-800">5. Managing Cookies</h2>
                <p className="text-gray-700 leading-relaxed mb-4">
                  You have the right to decide whether to accept or reject cookies. You can exercise your cookie preferences by:
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                  <li>Using the cookie consent tool on our website</li>
                  <li>Setting your browser to refuse all or some browser cookies</li>
                  <li>Deleting cookies that have already been set</li>
                </ul>
                <p className="text-gray-700 leading-relaxed mt-4">
                  Please note that if you choose to block cookies, you may not be able to access all or parts of our website, and some features may not function properly.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4 text-gray-800">6. How to Control Cookies in Your Browser</h2>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Most web browsers allow you to control cookies through their settings preferences. However, if you limit the ability of websites to set cookies, you may worsen your overall user experience. Here are links to cookie settings for popular browsers:
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                  <li>Google Chrome</li>
                  <li>Mozilla Firefox</li>
                  <li>Safari</li>
                  <li>Microsoft Edge</li>
                  <li>Opera</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4 text-gray-800">7. Updates to This Policy</h2>
                <p className="text-gray-700 leading-relaxed">
                  We may update this Cookie Policy from time to time to reflect changes in our practices or for other operational, legal, or regulatory reasons. Please revisit this Cookie Policy regularly to stay informed about our use of cookies.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4 text-gray-800">8. Contact Us</h2>
                <p className="text-gray-700 leading-relaxed mb-4">
                  If you have any questions about our use of cookies or this Cookie Policy, please contact us:
                </p>
                <div className="bg-blue-50 rounded-xl p-6">
                  <p className="text-gray-700">
                    <strong>Email:</strong> privacy@socialswingstudio.com<br />
                    <strong>Phone:</strong> (555) 123-4567
                  </p>
                </div>
              </section>
            </div>

            <div className="mt-12 text-center">
              <Link
                to="/privacy"
                className="inline-block bg-gradient-to-r from-blue-600 via-cyan-500 to-blue-400 text-white px-8 py-4 rounded-full font-bold text-lg hover:shadow-2xl transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                View Privacy Policy
              </Link>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default CookiesPage;
